import React from 'react'
import { Column } from 'primereact/column'
import AvTypeFilterTemplate from '../Filters/AvTypeFilterTemplate'
import { createColumnAttributes } from '../utils/createColumnAttributes'
import { getRowClassName } from '../utils/getRowClassName'
import { FilterMatchMode } from 'primereact/api'

/**
 * AV Type column component with dropdown filter
 * Displays AV types (Radio, Film/TV) for TV/Radio works only
 */
const AvTypeColumn = ({ title, mapsToField, filter, sortable, editable, isFieldChanged, isFieldChangedOverride, template, originalData, style }) => {
    const { filterAttributes, sortAttributes, checkFieldChanged } = createColumnAttributes({
        filter,
        title,
        sortable,
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    // Custom filter attributes for dropdown
    const customFilterAttributes = filter ? {
        filter: true,
        filterElement: (options) => <AvTypeFilterTemplate options={options} />,
        filterMatchMode: FilterMatchMode.EQUALS,
        showFilterMatchModes: false
    } : filterAttributes

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            style={style}
            body={(rowData) => (
                <span className={getRowClassName(checkFieldChanged, rowData)}>
                    {template ? template(rowData) : (rowData[mapsToField] || '-')}
                </span>
            )}
            {...customFilterAttributes}
        />
    )
}

export default AvTypeColumn
